<template>
  <div>
    <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="codiceRiga"
      :headers="headers"
      :items="righeDocumento"
      :options.sync="options"
      :server-items-length="totaleRighe"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      dense
    >
      <template v-slot:[`item.descrizione`]="{ item }">
        {{ (item.rigaIndentata ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '') + item.descrizione }}
      </template>
      <template v-slot:[`item.prezzoTotale`]="{ item }">
        {{ item.prezzoTotale | euro }}
      </template>        
      <template v-slot:[`item.sconto`]="{ item }">
        {{ item.sconto | euro }}
      </template>
      <template v-slot:[`item.prezzo`]="{ item }">
        {{ item.prezzo | euro }}
      </template>
      <template v-slot:[`item.aliquota`]="{ item }">
        {{ item.aliquota ? item.aliquota + '%' : '' }}
      </template>
      <template v-slot:[`item.imponibile`]="{ item }">
        {{ item.imponibile | euro }}
      </template>
      <template v-slot:[`item.iva`]="{ item }">
        {{ item.iva | euro }}
      </template>       
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom v-if="!item.rigaDescrittiva">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
          </template>
          <span>Modifica la riga</span>
        </v-tooltip>
        <v-tooltip bottom v-if="!item.rigaDescrittiva">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
          </template>
          <span>Cancella la riga</span>
        </v-tooltip>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid'
  import moment from 'moment'
  import documenti from '@/services/documentiService.js'
  import prodotti from '@/services/prodottiService.js'
  import _ from 'lodash'
  
  export default {
    components: {
    },
    props: {
      locDocumento: Object
    },
    data () {
      return {
        totaleRighe: 0,
        righeDocumento: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Codice', value: 'codice', align: 'start'},
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Quantità', value: 'quantita', align: 'end' },
          { text: 'UM', value: 'unitaMisura', align: 'end' },
          { text: 'Prezzo Totale', value: 'valore.prezzoTotale' , align: 'end'},
          { text: 'Sconto', value: 'sconto' , align: 'end'},
          { text: 'Importo Totale', value: 'prezzo' , align: 'end'},
          { text: 'Aliquota', value: 'aliquota' , align: 'end'},
          { text: 'Imponibile', value: 'imponibile' , align: 'end'},
          { text: 'Iva', value: 'iva' , align: 'end'},
          { text: 'Actions', value: 'actions', sortable: false }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        modelloDocumento: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreDocumento: ''
        // isModuloA4: false
      }
    },
    computed: {
      documentoId() {
        return this.locDocumento && this.locDocumento._id || null
      },
      dettaglioRiga() {
        let ed = this.editedItem
        if (!ed || !ed.prodotto || !ed.prodotto.variante1 || !ed.prodotto.variante2) return ''
        return `${ed.prodotto.descrizione } ${ed.prodotto.variante1.descrizione} ${ed.prodotto.variante2.descrizione}` 
      }      
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async documentiSaved(value) {
        if (value && this.dettaglioAperto) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'dettaglio')
        }
      },
      async documentoId(value) {
        if (value) {
          await this.getDataFromApi()
        }
      }
    },
    async created() {
      this.modelloDocumento = await documenti.getModello('xxx') // devo tenere una copia pulita
      this.defaultItem = this.modelloDocumento
    },
    async mounted () {
      //  await this.getDataFromApi()
      // this.impostazioniEtichette = await configurazioni.getConfigurazione('display_generale', 'etichette')
    },
    methods: {
      rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      },
      async getDataFromApi () {
        try {
          if(!this.documentoId) return
          this.loading = true
          const documento = await documenti.getDocumento(this.documentoId)
          this.totaleRighe = documento.righe.length
          this.righeDocumento = documento.righe.map (x => {
            return {
              sconti: x.valore && this.rigaSconti(x.valore), 
              descrizione: x.descrizione || _.get(x, 'prodotto.descrizione', ''),
              ...x
            }
          })
        } catch(err) {
          this.righeDocumento = []
          this.totaleRighe = 0
        } finally {
          this.loading = false
        }
      },
      async popolaModelloDaChiave() {
        const isCliente = _.get(this.chiaveDocumento,'tipoDocumento.visualizzaCliente', false)
        let mc = {
          codice: uuidv4(),
          valore: {
            listino: _.get(this.chiaveDocumento,`anagrafica.${isCliente ? 'cliente':'fornitore'}.amministrativi.listino`, {}),
            sconto1: _.get(this.chiaveDocumento,`anagrafica.${isCliente ? 'cliente':'fornitore'}.amministrativi.sconti.sconto1`, {}),
            sconto2: _.get(this.chiaveDocumento,`anagrafica.${isCliente ? 'cliente':'fornitore'}.amministrativi.sconti.sconto2`, {}),
            sconto3: _.get(this.chiaveDocumento,`anagrafica.${isCliente ? 'cliente':'fornitore'}.amministrativi.sconti.sconto3`, {}),
            sconto4: _.get(this.chiaveDocumento,`anagrafica.${isCliente ? 'cliente':'fornitore'}.amministrativi.sconti.sconto4`, null)
          },
          aliquotaIva: _.get(this.chiaveDocumento,`anagrafica.${isCliente ? 'cliente':'fornitore'}.amministrativi.aliquotaIva`, null)
        }
        const ivato = _.get(this.chiaveDocumento,`anagrafica.${isCliente ? 'cliente':'fornitore'}.amministrativi.listino.ivato`, true)
        _.set(mc, 'appoggio.listino.ivato', ivato)
        _.set(mc, 'appoggio.listino.nonIvato', !ivato)
        return mc
      },
      async onNuovaRiga() {
        this.editedIndex = -1
        this.editedItem = JSON.parse(JSON.stringify(this.modelloDocumento))
        const testata = await this.popolaModelloDaChiave()
        _.merge(this.editedItem, testata)
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      async editItem (item) {
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.completaAppoggio()
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      completaAppoggio() {
        let itm = this.editedItem
        _.set(this.editedItem,'appoggio.prodotto', itm.prodotto)
        _.set(this.editedItem,'appoggio.rigaDescrittiva', itm.rigaDescrittiva)
        _.set(this.editedItem,'appoggio.listino.ivato', _.get(itm,'valore.listino.ivato.ivato', true))
        _.set(this.editedItem,'appoggio.listino.nonIvato', !_.get(itm,'valore.listino.ivato.ivato', true))        
        _.set(this.editedItem, 'appoggio.importiModificati', _.get(itm,'valore.importiModificati', false))
      },
      duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      deleteItem (item) {
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        this.righeDocumento.splice(this.editedIndex, 1)
        // TODO: ATTENZIONE VA VERIFICATO CHE NON ABBIA STORIA
        if (!await documenti.cancellaDocumento(this.editedItem.documento.id)) {
          this.dialogErrore = true
        }
        if (!await prodotti.aggiornaDeltaGiacenza(
            this.editedItem.items.prodotto._id,
            this.editedItem.items.documento.magazzino,
            -this.editedItem.items.documento.quantita
          )
        ) {
          this.dialogErrore = true
        }
        this.closeDelete()
        this.editedIndex = -1
        this.editedItem = Object.assign({}, null)        
      },

      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      async save () {
        this.$store.commit('documentiDettaglio/CLEAR_RIGA_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['documentiDettaglio/rigaDocumento']
        let documento = await documenti.getDocumento(this.chiaveDocumento._id)
        if (this.editedIndex > -1) {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          Object.assign(this.righeDocumento[this.editedIndex], this.editedItem)
          Object.assign(documento.righe[this.editedIndex], this.editedItem)
        } else {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          this.righeDocumento.push(this.editedItem)
          documento.righe = documento.righe || []
          documento.righe.push(this.editedItem)
        }
        if (!await documenti.aggiornaDocumento(documento)) {
          this.dialogErrore = true
          return
        }
        this.close()
        this.$store.commit('documentiDettaglio/CLEAR_RIGA_DOCUMENTO')
        await this.getDataFromApi()
      },      
      erroreConfirm() {
        this.dialogErrore = false
        this.erroreDocumento = ''
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editedIndex = this.righeDocumento.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('documentiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        }) 
        return elaborati
      },
      deleteDatiVisualizzazione(documento) {
        let locDocumento = {...documento}
        delete locDocumento.c_nominativo
        delete locDocumento.appoggio
        return locDocumento
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.articoliSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
